import React, { useMemo } from 'react';
import LateralMenu from '../LateralMenu';
import { faBug, faClipboardList, faFileSignature, faGear, faSearch, faShield, faCar, faMemoCircleCheck, faMemoCircleInfo, faIdBadge } from '@fortawesome/pro-regular-svg-icons';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_app_agent.png';
import collapsedLogo from '../../../assets/icon_app_agent.png';
import { useCurrentApp } from '../../context/CurrentApp';

export default function AppAgentLateralMenu({
    navigation,
    open,
    authenticatedUser,
    setOpen,
    selectedMenu
}: LateralMenuProps) {
    const { isParentApp } = useCurrentApp();
    const allowedPersonOfInterest = useMemo(() => window.location.hostname.includes('parapicuiba') || isParentApp, [window.location]);

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            open={open}
            setOpen={setOpen}
            authenticatedUser={authenticatedUser}
            items={[{
                icon: faClipboardList,
                text: translate('occurrences'),
                action: () => navigation.navigate('AppAgent', { screen: 'AgentOccurrences' }),
                selected: selectedMenu === 'occurrences'
            }, {
                icon: faShield,
                text: translate('teams'),
                action: () => navigation.navigate('AppAgent', { screen: 'AgentUnits' }),
                selected: selectedMenu === 'units'
            }, {
                icon: faSearch,
                text: translate('searchOnCortex'),
                action: () => navigation.navigate('AppAgent', { screen: 'CortexFinder' }),
                selected: selectedMenu === 'cortex-finder',
                omit: !(
                    authenticatedUser?.isAdmin ||
                    authenticatedUser?.permissions.search_people_cortex ||
                    authenticatedUser?.permissions.search_cortex_any_time
                )
            }, {
                icon: faIdBadge,
                text: translate('personOfInterest'),
                action: () => navigation.navigate('AppAgent', { screen: 'PersonOfInterest' }),
                selected: selectedMenu === 'person-of-interest',
                omit: !allowedPersonOfInterest
            }, {
                icon: faFileSignature,
                text: translate('signatures'),
                action: () => navigation.navigate('AppAgent', { screen: 'AgentSignatures' }),
                selected: selectedMenu === 'signatures'
            }, {
                icon: faMemoCircleInfo,
                text: translate('openVacancies'),
                action: () => navigation.navigate('AppAgent', { screen: 'OpenVacancies' }),
                selected: selectedMenu === 'open-vacancies',
                omit: !authenticatedUser?.permissions.app_agent_deac_access
            }, {
                icon: faMemoCircleCheck,
                text: translate('myCandidacies'),
                action: () => navigation.navigate('AppAgent', { screen: 'Candidacies' }),
                selected: selectedMenu === 'my-candidacies',
                omit: !authenticatedUser?.permissions.app_agent_deac_access
            }, {
                icon: faBug,
                text: translate('debugger'),
                action: () => navigation.navigate('AppAgent', { screen: 'Debugger' }),
                selected: selectedMenu === 'debugger',
                omit: !window.AndroidBridge
            }, {
                icon: faGear,
                text: translate('services'),
                action: () => navigation.navigate('AppAgent', { screen: 'Services' }),
                selected: selectedMenu === 'services',
                omit: !window.AndroidBridge
            }, {
                icon: faCar,
                text: translate('lprEvents'),
                action: () => navigation.navigate('AppAgent', { screen: 'LprEvents' }),
                selected: selectedMenu === 'lpr-events',
                omit: !(window.AndroidBridge && authenticatedUser?.permissions.app_agent_manage_services)
            }]}
        />
    );
}
